module.exports = __webpack_public_path__ + "assets/img/scss_default_base.e0500dc9.jpg";